import React from 'react';
import LocalizacaoGridListPageContainer from './LocalizacaoGridListPageContainer';

export class LocalizacaoGridListPage extends React.Component{
    
    render(){
      return (
        <LocalizacaoGridListPageContainer {...this.props}/>
      )
    }
}

